import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { CatalogProvider } from "@/data/catalog";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Checkout from "@/pages/Checkout";
import { ensureEcwidScript } from "@/lib/ecwidCheckout";
import Community from "@/pages/Community";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductPage from "@/pages/ProductPage";

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const lenis = window.__lenis;
    if (location.hash) {
      const t = setTimeout(() => {
        let el = null;
        try {
          el = document.querySelector(location.hash);
        } catch {
          // Not a CSS selector (e.g. Ecwid's #!/~/cart hashbang) — no anchor scroll
        }
        if (el && lenis) lenis.scrollTo(el, { offset: -96 });
        else if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 80);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location]);

  return null;
};

function App() {
  useEffect(() => {
    // Preload the Ecwid storefront script (deferred — nothing renders) so
    // checkout initializes fast when the user gets there.
    ensureEcwidScript();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-obsidian min-h-screen text-stone font-body">
      <CartProvider>
        <CatalogProvider>
        <BrowserRouter>
          <ScrollManager />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/community" element={<Community />} />
            <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/checkout" element={<Checkout />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <CartDrawer />
        </BrowserRouter>
        </CatalogProvider>
        <Toaster theme="dark" position="bottom-right" />
      </CartProvider>
    </div>
  );
}

export default App;
